import React from "react";
import { NotFound } from "@app/pages/Features";
import { AdminPermissions } from "@app/constants";
import { useAdminPermissions } from "./useAdminPermissions";

type Props = {
  required: AdminPermissions | AdminPermissions[];
  children: React.ReactNode;
};

export function RestrictedByPermission({ required, children }: Props) {
  const { permissions, loading } = useAdminPermissions();

  if (loading) return null;

  const requiredPermissions = Array.isArray(required) ? required : [required];

  const allowed = requiredPermissions.some(
    (perm) => permissions?.[perm] === true
  );

  if (!allowed) {
    return <NotFound />;
  }

  return <>{children}</>;
}
